interface PROPS {
  children: JSX.Element;
}

export function G_UI_FIELD__image_asset_empty_base({ children }: PROPS) {
  return <div className="flex flex-col gap-1 w-full bg-component p-2 relative">{children}</div>;
}
